import { render, staticRenderFns } from "./ProcessPopup.vue?vue&type=template&id=1950edd2&scoped=true&"
import script from "./ProcessPopup.vue?vue&type=script&lang=js&"
export * from "./ProcessPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProcessPopup.vue?vue&type=style&index=0&id=1950edd2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1950edd2",
  null
  
)

export default component.exports